import { PureComponent } from 'react';

export default class Dollar extends PureComponent {
    componentDidMount() {
        this.rendertoHtml();
    }

    componentDidUpdate() {
        this.rendertoHtml();
    }

    rendertoHtml = () => {
        const {
            children,
            currency = 'USD',
            omit,
        } = this.props;
        const dot =
            omit && children && children - children.toFixed(2) != 0
                ? '...'
                : '';
        const formatted = `${currency}$ ${
            children || children === 0
                ? Number(Math.abs(children)).toLocaleString('en-US', { minimumFractionDigits: 2 })
                : 'N/A'
            } ${dot}`;
        if (this.main) {
            this.main.innerHTML = children < 0 ? `(${formatted})` : formatted;
        }
    };

    render() {
        const { children } = this.props;
        return (
            <span
                style={{ color: children < 0 ? 'red' : 'unset' }}
                ref={(ref) => {
                    this.main = ref;
                }}
            />
        );
    }
}
